import axios from "axios";
import { eAccessRights } from "../enums";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";

export type IAccessRightsReturn = IAxiosReturn<eAccessRights[]>;

/**
 * Gets my access rights for a specific hierarchy.
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @param hierarchyId - The unique identifier of the hierarchy to check access for
 * @param controller - Optional AbortController for cancelling the request
 * @returns A promise resolving to `IAccessRightsReturn` with access rights for the specified hierarchy.
 */
export const getMyAccess = async (
  backEndUrl: string,
  hierarchyId: string,
  controller: AbortController,
): Promise<IAccessRightsReturn> => {
  const url = `${backEndUrl}UserAccess/UserPermissions/Me/Hierarchies/${hierarchyId}`;
  // Get data
  try {
    const response: { data: eAccessRights[] } = await axios.get(url, { signal: controller.signal });
    // Return successful result
    return {
      success: true,
      data: response.data,
    };
  } catch (error: unknown) {
    return processAxiosError("Load my access failed", error);
  }
};
